module.exports = __webpack_public_path__ + "static/media/service_breakfast.801a3c75.jpg";